// The swing slider's arithmetic (SwingRatioSlider.tsx), apart from the
// component so it fast-refreshes: whole steps of a hundredth of a beat counted
// from the mark, and the drag that lands on the mark.

/** One step of the slider: a hundredth of a beat. */
export const SWING_SLIDER_STEP = 0.01;

/** The ratio, offset and steps a slider shows for a stored offset. */
export function swingSliderModel(
  base: number,
  range: readonly [number, number],
  offset: number,
): { min: number; max: number; steps: number; ratio: number } {
  const [lo, hi] = range;
  // Whole steps either side of the mark, so the mark is on the slider's grid;
  // the last step may run past the range, which holds what plays.
  const min = -Math.ceil((base - lo) / SWING_SLIDER_STEP - 1e-9);
  const max = Math.ceil((hi - base) / SWING_SLIDER_STEP - 1e-9);
  const steps = Math.min(max, Math.max(min, Math.round(offset / SWING_SLIDER_STEP)));
  const ratio = Math.min(hi, Math.max(lo, base + offset));
  return { min, max, steps, ratio };
}

/** The offset a slider position writes; a drag one step from the mark is the mark. */
export function swingSliderOffset(steps: number, dragging: boolean): number {
  if (dragging && Math.abs(steps) <= 1) return 0;
  return Math.round(steps * SWING_SLIDER_STEP * 1000) / 1000 || 0;
}
